<template>
	<section>
		<!--工具条-->
		<el-col :span="24" style="padding-top:15px;">
			<div>
				<el-tabs v-model="sysSourceOptName" @tab-click="tabHandleClick">				
					<el-tab-pane v-for="i in sysSourceList" :label="i.name" :value="i.code"></el-tab-pane>
			    </el-tabs>
				<label  v-if="sysSourceTabSelected != 'AF'"  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">系统类型:</label>
				<el-select v-if="sysSourceTabSelected != 'AF'"   v-model="filterForm.appSourceCode" placeholder="全部" style="width: 180px;">
					<el-option label="全部" value="all"></el-option>
					<el-option v-for="(item,index) in sysAppList"  v-bind:key="index"  :label="item.name" :value="item.key"></el-option>
				</el-select>
				<label  style="width: 80px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">项目归属:</label>
				<el-input  placeholder="请选择项目" suffix-icon="el-icon-date" style="width: 150px" @focus="showProjectTree" v-model="projectNames"></el-input>
				<el-dialog  title="项目归属" v-model="projectTreeDialogVisible" >
				<div style="">
					<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
					<el-tree class="filter-tree" :data="projectTree"  show-checkbox node-key="id" :default-checked-keys="projectTreeDefaultChecked" :filter-node-method="filterNode" ref="projectTree"></el-tree>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="projectTreeOnCancel">取 消</el-button>
					<el-button type="primary" @click="projectTreeOnSubmit">确 定</el-button>
				</div>
				</el-dialog>
				<label  style="width: 80px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">名称:</label>
				<el-input style="width: 180px;" placeholder="输入名称/编号" v-model="filterForm.deviceName">
				</el-input>
				<label  style="width: 80px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">地址:</label>
				<el-input style="width: 180px;" placeholder="输入地址" v-model="filterForm.deviceAddress">
				</el-input>
				
			</div>
		</el-col>
		<el-col :span="24" style="padding-top:10px;padding-bottom:14px;border-bottom: 1px solid rgb(209, 219, 229);">
			<label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 38px;box-sizing: border-box;">类型:</label>
				<el-select   v-model="filterForm.deviceType" style="width: 180px"> 
					<el-option label="全部" value="all"></el-option>
					<el-option v-for="(item,index) in typeList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
				</el-select>
				<label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">时间:</label>
				<div style="display:inline;">
					<el-date-picker style="width:120px;" v-model="searchMonth" value-format="yyyyMM"  format="yyyyMM" type="month" :placeholder="searchMonthValue" @change="searchMonthOnChange"></el-date-picker>
				</div>
				<el-button style="margin-left: 15px;" @click="queryBtn()">查询</el-button>
				<el-button @click="exportData">数据导出</el-button>
		</el-col>

		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="projectName" label="所属项目" width="140" sortable>
			</el-table-column>
			<el-table-column prop="sysCodeName" label="系统类型" width="140" sortable>
			</el-table-column>
			<el-table-column prop="deviceName" label="名称" width="150"  sortable>
			</el-table-column>
			<el-table-column prop="sn" label="编号" width="130" sortable>
			</el-table-column>
			<el-table-column prop="deviceAddress" label="地址" width="140" sortable>
			</el-table-column>
			<el-table-column prop="alarmContent"  label="数据内容" width="150" sortable>
			</el-table-column>
			<el-table-column prop="deviceType" label="类型" width="120" sortable>
			</el-table-column>
			<el-table-column prop="alarmTime" label="上报时间" width="150" sortable>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import Treeselect from '@riophae/vue-treeselect'
	import global from '@/config/global_config'
	import Vue from 'vue'
	import router from '@/router/index.js'
	
	export default {
		components: { Treeselect },
		watch: {
			filterText(val) {
				this.$refs.projectTree.filter(val);
			}
        },
		data() {
			return {
				userRoleIdentity:global.getCurrentUser().roleIdentity,
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],
				filterForm: {
					deviceType: '',
					appSourceCode: ''
				},
				typeList:[],
				projectSysSourceList_Original: [],
			    projectSysSourceList: [],
				addFormVisible: false,
				addLoading: false,
				businessGroupIdsSelect:'',
				sysSourceListVisible:false,
				projectTree:[],
				projectTreeDefaultChecked:[],
				filterText:'',
				projectTreeDialogVisible:false,
				projectNames:'',
				projectIds:'',
				shortAcountList:[],
				shortAcountList_tree:[],
				search_word:'',
				bulidYear:'',
				catchTime:'',
				editSubmitButtonDisabled:false,
				addSubmitButtonDisabled:false,
				businessTypeList:[],
				regionAreaList:[],
				tableSelectionIds:'',
				filterDeviceModel:'',
				filterSysCode:'',
				projectList:[],
				sysSourceList:[],
				sysSourceTabSelected:'',
				sysSourceOptName:'',
				searchMonth: '',
				searchMonthValue:tools.getCurrentYear()+''+tools.getCurrentMonth(),
				sysAppList:[],
			}
		},
		methods: {
			tabHandleClick(tab, event) {
				console.log(this.filterForm.deviceType);
				this.sysSourceTabSelected = this.sysSourceList[tab.index].code;
				this.filterForm.deviceType = '';
				this.filterForm.appSourceCode = '';
				console.log(this.filterForm);
				this.getTypeList();
				this.getSysAppList(this.sysSourceTabSelected);
				this.get_list_data();
			},
			getSysAppList(sysSource){
				if(sysSource == "FAS"){
					let param = {};
					api.assetsManage_fas_getSysAppList_request(param).then((res) => {
						this.sysAppList = res.data;	
					}).catch((e) => {
						console.log(e);
					});
				}
				else if(sysSource == "BA"){
					let param = {};
					api.assetsManage_ba_getSysAppList_request(param).then((res) => {
						this.sysAppList = res.data;	
					}).catch((e) => {
						console.log(e);
					});
				}
				else if(sysSource == "WL"){
					let param = {};
					api.assetsManage_terminal_getSysAppList_request(param).then((res) => {
						this.sysAppList = res.data;	
					}).catch((e) => {
						console.log(e);
					});
				}
			},
			searchMonthOnChange(val) {  
				this.searchMonthValue = val;  
			},
			// startMonthOnChange(val) {  
			// 	this.startMonthValue = val;  
			// },
			// endMonthOnChange(val) {  
			// 	this.endMonthValue = val;
			// },
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			handleSearch(){
				this.get_list_data();
			},
			hiddenSysSourceList(){
				this.sysSourceListVisible = false;
			},
			showSysSourceList(){
				this.sysSourceListVisible = true;
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
			},
			projectTreeOnCancel(){
				this.$refs.projectTree.setCheckedNodes([]);
				this.projectTreeDialogVisible = false;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let leafCheckedNodeNames = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children){
							leafCheckedNodes.push(one.id);
							leafCheckedNodeNames.push(one.label);
						}
					});
					this.projectNames = leafCheckedNodeNames.join(',');
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			queryBtn(){
				this.get_list_data();
			},
			get_list_data() {
				let appSourceCode = this.sysSourceTabSelected ? this.sysSourceTabSelected : this.sysSourceOpt;
				let param = {
					keys:this.filterForm.deviceName,
					deviceAddress:this.filterForm.deviceAddress,
					pageNum: this.page,
					appSourceCode:appSourceCode,
					projectIds:this.projectIds,
					pageSize:15,
					searchYm:this.searchMonthValue,
				};
				if(null != this.filterForm.deviceType && this.filterForm.deviceType.length>0) {
					if(this.filterForm.deviceType == 'all')param.deviceType = null;
					else param.deviceType = this.filterForm.deviceType;
				}
				if(null != this.filterForm.appSourceCode && this.filterForm.appSourceCode.length>0){
					if(this.filterForm.appSourceCode == 'all')param.sysCode= null;
					else param.sysCode = this.filterForm.appSourceCode;
				}
				this.listLoading = true;
				api.normalData_getPageList_request(param).then((res) => {
					this.total = res.data.total;
					this.list_data = res.data.list;
					this.listLoading = false;
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			getTypeList: function () {
				let param = {
					sysSource:this.sysSourceTabSelected
				};
				api.normalData_getTypeList_request(param).then((res) => {
					this.typeList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
			},
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
					let temp = [];
					this.projectList = [];
					if(res.data){
						for (let index = 0; index < res.data.length; index++) {
							temp[index] = {id:-res.data[index].groupId ,label:res.data[index].groupName,children:[]};
							res.data[index].projectList.forEach(one => {
								temp[index].children.push({id:parseFloat(one.projectId),label:one.projectName});
								this.projectList.push({id:one.projectId,name:one.projectName});
							});
						}
					}
					this.projectTree = temp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			getShortAcountList: function (projectId) {
				let param = {projectId:projectId};
				this.listLoading = true;
				api.project_getProjectAcountAble_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].id ,label:res.data[index].code};
					}
					this.shortAcountList_tree = temp;
					this.shortAcountList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			handleDataExport:function () {

			},
			selsChange: function (sels) {
				this.sels = sels;
				this.tableSelectionIds = "";
				this.sels.forEach(one => {
					if(this.tableSelectionIds.length == 0){
						this.tableSelectionIds = one.deviceId;
					}
					else
					this.tableSelectionIds = this.tableSelectionIds +","+one.deviceId;
				})
			},
			exportData:function () {
				let appSourceCode = this.sysSourceTabSelected ? this.sysSourceTabSelected : this.sysSourceOpt;
				let param = {
					keys:this.filterForm.deviceName,
					deviceAddress:this.filterForm.deviceAddress,
					appSourceCode:appSourceCode,
					projectIds:this.projectIds,
					searchYm:this.searchMonthValue,
				};
				if(null != this.filterForm.deviceType && this.filterForm.deviceType.length>0) {
					if(this.filterForm.deviceType == 'all')param.deviceType = null;
					else param.deviceType = this.filterForm.deviceType;
				}
				if(null != this.filterForm.appSourceCode && this.filterForm.appSourceCode.length>0){
					if(this.filterForm.appSourceCode == 'all')param.sysCode= null;
					else param.sysCode = this.filterForm.appSourceCode;
				}
				this.listLoading = true;
				api.normalData_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'routineDataList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			bulidYearOnChange(val) {  
				this.bulidYear = val;
				if(this.editFormVisible) this.editForm.bulidYear =val;
				else this.addForm.bulidYear =val;
			},
			catchTimeOnChange(val) {  
				this.catchTime = val;
				if(this.editFormVisible) this.editForm.catchTime =val;
				else this.addForm.catchTime =val;
			},
			updateAcountListTreeValue(state, value){
				state.value = value
			},
			getSysSourceList: function () {
				let param = {};
				this.listLoading = true;
				api.system_getSysSourceList_request(param).then((res) => {
					if(tools.strIsEmpty(res.data)){
						return;
					}
					for (let index = 0; index < res.data.length; index++) {
						if(res.data[index].code =='AF'){
							res.data.splice(index,1);
						}
						if(res.data[index].code =='FAS'){
							res.data.splice(index,1);
						}
					}
					this.sysSourceList = res.data;
					this.sysSourceTabSelected = this.sysSourceList[0].code;
					this.getTypeList();	
					this.getSysAppList(this.sysSourceTabSelected);
					this.get_list_data();
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
		},
		mounted() {
			this.getSysSourceList();
			this.getProjectTree();
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// routine_data_list.vue?34712b76